import { render, staticRenderFns } from "./CopyCompanyStage.vue?vue&type=template&id=3ec78b50&scoped=true&"
import script from "./CopyCompanyStage.vue?vue&type=script&lang=js&"
export * from "./CopyCompanyStage.vue?vue&type=script&lang=js&"
import style0 from "./CopyCompanyStage.vue?vue&type=style&index=0&id=3ec78b50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec78b50",
  null
  
)

export default component.exports